export default __webpack_public_path__ + "assets/images/525-small.png";